<template>
  <!-- 任务类型卡片标题 -->
  <div>
    <div class="mx-4 font-bold red-dot flex justify-between items-center">
      {{ $t(`mission.type`) }}
      <button
        v-if="isEdit"
        :class="[
          'btn btn-xs btn-outline',
          dispatchMission.mission ? '' : 'btn-primary',
        ]"
        @click="clickSelectType"
      >
        {{ $t(`mission.selectType`) }}
      </button>
    </div>

    <div class="ml-4 text-base-content/70 text-xs pt-2">
      <div class="flex items-center gap-2 font-bold">
        <span>{{
          dispatchMission.mission?.name ?? "当前还未选择任务类型"
        }}</span>
      </div>
    </div>

    <VanPopup
      v-model:show="showMissionList"
      class="h-[80%] py-4 overflow-hidden flex flex-col"
      position="bottom"
    >
      <div class="mx-4 text-base font-bold red-dot mb-2 flex justify-between">
        <span>
          {{
            $t(`mission.cardType`) +
            (isEdit
              ? $t(`mission.cardTypeCount`, {
                  count: missionStore.missionList.length,
                })
              : "")
          }}
        </span>

        <div class="flex gap-2">
          <button
            class="btn btn-xs btn-outline"
            @click="showMissionList = false"
          >
            {{ $t(`Buttons.cancel`) }}
          </button>
          <button class="btn btn-xs btn-primary" @click="clickConfirm()">
            {{ $t(`Buttons.confirm`) }}
          </button>
        </div>
      </div>

      <div class="flex-1 overflow-hidden flex flex-col">
        <!-- 任务类型卡片区域 -->
        <div class="px-4 flex gap-2 overflow-x-auto mb-2">
          <!-- 探险任务卡片 -->

          <div
            v-for="(item, idx) in missionStore.missionList"
            :key="idx"
            :class="[
              'card w-[300px] h-[168px] shadow-md border relative overflow-hidden flex-shrink-0',
              item.id === activeMission?.id ? 'border-primary' : 'grayscale',
            ]"
            @click="clickMission(item)"
          >
            <BaseImg
              :url="item.coverMedia.url"
              alt=""
              crossorigin="anonymous"
              class="absolute top-0 left-0 right-0 bottom-0 object-cover z-[1]"
            />

            <div
              class="absolute bottom-0 left-0 right-0 h-[174px] darken-linear-background-b z-[2]"
            />

            <div
              class="p-3 z-[3] absolute bottom-0 left-0 text-white font-[Cubic]"
            >
              <div class="flex items-baseline gap-1">
                <h2 class="text-lg">{{ item.name }}</h2>
                <div class="text-[10px]">{{ item.shortDescription }}</div>
              </div>
              <div class="text-xs mt-0.5">
                {{ `${$t("mission.suitableTrait")} ：${item.suitableTrait}` }}
              </div>
            </div>
          </div>
        </div>

        <!-- 奖励与风险说明 -->
        <div
          class="flex-1 p-4 bg-neutral mx-4 text-xs text-neutral-content mb-2 overflow-y-auto"
          v-if="activeMission"
        >
          <div class="text-success">
            <span>{{ $t(`mission.reward`) }}：</span>
            <span>{{ activeMission?.reward }}</span>
          </div>
          <div class="text-error">
            <span>{{ $t(`mission.risk`) }}：</span>
            <span>{{ activeMission?.risk }}</span>
          </div>
          <div class="mt-2">
            {{ activeMission?.description }}
          </div>
          <div class="mt-1 text-neutral-content/60">
            "{{ activeMission?.motto }}"
          </div>
        </div>
      </div>
    </VanPopup>
  </div>
</template>

<script setup lang="ts">
import { useMission } from "@/stores/mission";
import { DispatchMission, MateDispatch } from "@/types/entity";
import { onMounted, ref } from "vue";
import { checkAndInitObjective } from "./MissionGenerate";
const props = defineProps<{
  isEdit: boolean;
  dispatchMission: Partial<MateDispatch>;
}>();

const activeMission = ref<DispatchMission>();

const missionStore = useMission();

const clickMission = (m: DispatchMission) => {
  activeMission.value = m;
};
const showMissionList = ref(false);

const clickConfirm = async () => {
  const pass = await checkAndInitObjective(props.dispatchMission);
  if (!pass) return;

  const { dispatchMission } = props;
  dispatchMission.mission = activeMission.value!;
  showMissionList.value = false;
};

const clickSelectType = () => {
  showMissionList.value = true;
  activeMission.value = props.dispatchMission.mission!;
};

onMounted(() => {
  const { dispatchMission } = props;
  activeMission.value = dispatchMission.mission;
});
</script>
